import {SellerError} from './SellerError.js'

export class InvalidRequestSellerError extends SellerError {}
